
import { PanelRight } from "lucide-react";
import { useIsMobile } from "@/lib/useMediaQuery";
import { useEditMode } from "../hooks/useEditMode";
import { useSidePanel } from "../hooks/useSidePanel";
import { cn } from "@/lib/utils";

/**
 * Mobile-only floating action button for opening the side panel.
 * Positioned in the bottom-left corner to avoid conflict with
 * the ImmersiveToolbar (bottom-right when minimized).
 *
 * Only visible on mobile in editing mode.
 */
export function MobileFAB() {
  const isMobile = useIsMobile();
  const { isReadonly } = useEditMode();
  const { sidePanelOpen, toggleSidePanel } = useSidePanel();

  // Only show on mobile, and not when the panel is already open
  if (!isMobile || isReadonly || sidePanelOpen) return null;

  return (
    <button
      onClick={toggleSidePanel}
      className={cn(
        "fixed bottom-4 left-4 z-30",
        "w-12 h-12 flex items-center justify-center rounded-full",
        "bg-white/90 backdrop-blur-sm border border-sands-200 shadow-lg",
        "text-sands-600 hover:text-sands-800 hover:bg-white",
        "active:scale-95 transition-all duration-150",
      )}
      title="Open editor panel"
    >
      <PanelRight className="w-5 h-5" />
    </button>
  );
}
